/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "action-attach": [{
    "type": 0,
    "value": "Attach file"
  }],
  "action-send": [{
    "type": 0,
    "value": "Send message"
  }],
  "attachment-count-error": [{
    "type": 0,
    "value": "Too many attachments - "
  }, {
    "type": 1,
    "value": "n"
  }, {
    "type": 0,
    "value": " maximum"
  }],
  "attachment-fetch-error": [{
    "type": 1,
    "value": "fileName"
  }, {
    "type": 0,
    "value": " failed to upload due to an unknown error."
  }],
  "attachment-size-error": [{
    "type": 1,
    "value": "attachment"
  }, {
    "type": 0,
    "value": " too large - 5MB maximum"
  }],
  "attachment-validate-message": [{
    "type": 0,
    "value": "Validating attachments..."
  }],
  "remove-attachment": [{
    "type": 0,
    "value": "Remove attached file "
  }, {
    "type": 1,
    "value": "attachment"
  }],
  "thumbnail-alt": [{
    "type": 0,
    "value": "Open modal preview of "
  }, {
    "type": 1,
    "value": "attachment"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var DefaultTranslationComp = Object.assign(TranslationProviderComponent, {
  translations
});

export { DefaultTranslationComp as D };
//# sourceMappingURL=en-US-eYvf6UDF.js.map
